import React from 'react'

const Loader = () => {
    return (
        <div className='loader-admin'>
            <div className="loader-container">
            </div>
        </div>
    )
}

export default Loader